<div class="pdf-content">
  @if (url) {
    <div class="pdf-viewer">
      <object #pdfViewer [data]="safeResourceUrl" type="application/pdf"></object>
    </div>
  }
</div>
